// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"7ed2cf0d","338":"caf1fd2b","482":"bc9b3e0e","488":"1e8cc5e1","784":"f323da36"}[chunkId] + ".chunk.js";
};